import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import LuxPlusDestinationCarousel from './LuxPlusDestinationCarousel'
import LuxPlusLandingBenefitsList from './LuxPlusLandingBenefitsList'
import LuxPlusLandingPartnerOffersSection from './LuxPlusLandingPartnerOffersSection'
import LuxPlusLandingOfferCarousels from './LuxPlusLandingOfferCarousels'
import LuxPlusLandingFaqSection from './LuxPlusLandingFaqSection'
import LuxPlusLandingBottomCTA from './LuxPlusLandingBottomCTA'
const DestinationCarouselWrapper = styled.div`
  margin-top: ${rem(40)};
`

function LuxPlusLandingBenefitsSection() {
  return (<>
    <LuxPlusLandingBenefitsList />
    <DestinationCarouselWrapper>
      <LuxPlusDestinationCarousel />
    </DestinationCarouselWrapper>
    <LayoutContainer>
      <LuxPlusLandingPartnerOffersSection />
    </LayoutContainer>
    <LuxPlusLandingOfferCarousels />
    <LuxPlusLandingFaqSection />
    <LuxPlusLandingBottomCTA />
  </>)
}

export default LuxPlusLandingBenefitsSection
